module.exports = __webpack_public_path__ + "img/tooth4.2930df70.png";